import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import './ChangePassword.css';

function ChangePassword() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    const loadUser = async () => {
      try {
        const userData = await api.get('/auth/me');
        setUser(userData);
        
        if (!userData.passwordChangeRequired) {
          navigate('/');
        }
      } catch (error) {
        console.error('Error loading user:', error);
        navigate('/login');
      }
    };

    loadUser();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.newPassword !== formData.confirmPassword) {
      setError('Die neuen Passwörter stimmen nicht überein');
      return;
    }

    if (formData.newPassword.length < 6) {
      setError('Das neue Passwort muss mindestens 6 Zeichen lang sein');
      return;
    }

    setLoading(true);

    try {
      await api.post('/auth/change-password', {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword
      });

      const userData = await api.get('/auth/me');
      localStorage.setItem('user', JSON.stringify(userData));

      setTimeout(() => {
        if (userData.role === 'admin') {
          window.location.href = '/admin';
        } else {
          window.location.href = '/';
        }
      }, 100);
    } catch (error) {
      setError(error.response?.data?.error || 'Fehler beim Ändern des Passworts');
      setLoading(false);
    }
  };

  if (!user) {
    return <div className="change-password-container"><Spinner /></div>;
  }

  return (
    <div className="change-password-container">
      <div className="change-password-box">
        <h2>Passwort ändern</h2>
        <p className="change-password-info">
          Sie müssen Ihr Passwort ändern, bevor Sie fortfahren können.
        </p>
        <form onSubmit={handleSubmit} className="change-password-form">
          <div className="form-group">
            <label>Aktuelles Passwort</label>
            <input
              type="password"
              value={formData.currentPassword}
              onChange={(e) => setFormData({ ...formData, currentPassword: e.target.value })}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Neues Passwort</label>
            <input
              type="password"
              value={formData.newPassword}
              onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })}
              required
              minLength={6}
            />
          </div>
          <div className="form-group">
            <label>Neues Passwort bestätigen</label>
            <input
              type="password"
              value={formData.confirmPassword}
              onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
              required
              minLength={6}
            />
          </div>
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          <button 
            type="submit" 
            className="btn-primary" 
            disabled={loading}
          >
            {loading ? 'Passwort wird geändert...' : 'Passwort ändern'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;
